import React from 'react';
import { DashboardManagement } from '../features/dashboard';

/**
 * DashboardPage - Admin dashboard page
 */
export const DashboardPage: React.FC = () => {
  return <DashboardManagement />;
};

export default DashboardPage;
